<template>
  <div class="contact-link">
    <img src="@/assets/img/icons.svg#icon-contact-small" width="20" height="20">
    {{text}}
  </div>
</template>

<script>
  export default {
    name: "LinkContact",
    props: ['text', 'href']
  }
</script>

<style lang="scss">
  .contact-link {
    margin-bottom: 0;
    cursor: pointer;

    img {
      margin-right: rem(5px);
    }
  }
</style>